import { message } from "antd";
import { useState } from "react";
import { Switch } from "V2.0/common/switch";
import { showErrorToast } from "V2.0/utils";
import { updateAssistant } from "../../service";
import { ClockIcon } from "@heroicons/react/24/outline";

export default function ApplyOfficeHoursToQueue(props) {
  const {
    assistantId,
    workspaceId,
    syncAssistant,
    communicationQueueSettings,
    locked,
  } = props;

  const [state, setState] = useState({
    applyOfficeHoursToQueue:
      communicationQueueSettings?.applyOfficeHoursToQueue ?? false,
  });

  const handleUpdateApplyOfficeHoursToQueue = async (state) => {
    const lifecycleCbs = {
      init: () => {
        message.loading("Updating Settings");
      },
      success: () => {
        message.destroy();
        message.success("Settings Updated");
      },
      error: (e) => {
        message.destroy();
        showErrorToast(e, "Failed to update Settings");
      },
    };

    const payload = {
      assistantSettings: {
        communicationQueueSettings: {
          applyOfficeHoursToQueue: state,
        },
      },
    };

    lifecycleCbs.init();

    try {
      const response = await updateAssistant({
        projectId: workspaceId,
        assistantId,
        payload,
      });

      if (response.status === 200) {
        lifecycleCbs.success();
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            communicationQueueSettings: {
              applyOfficeHoursToQueue: state,
            },
          };
        });
      }
    } catch (e) {
      lifecycleCbs.error(e);
      setState({
        applyOfficeHoursToQueue: !state,
      });
    }
  };

  return (
    <div className="rounded-lg border border-indigo-100 bg-indigo-50/60 px-4 py-3">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-x-2.5">
          <div className="relative shrink-0 mt-0.5">
            <ClockIcon className="size-5 text-indigo-500" />
            <span
              className={`absolute -bottom-0.5 -right-0.5 size-2 rounded-full ring-2 ring-indigo-50 ${
                state.applyOfficeHoursToQueue ? "bg-emerald-500" : "bg-gray-300"
              }`}
            />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900">
              Apply Assistant's Office Hours
            </p>
            <p className="text-xs text-gray-500 mt-0.5">
              Pending calls in the queue will be processed during the assistant's office hours.
            </p>
          </div>
        </div>

        <Switch
          color="emerald"
          onChange={(checked) => {
            setState({
              applyOfficeHoursToQueue: checked,
            });
            handleUpdateApplyOfficeHoursToQueue(checked);
          }}
          checked={state.applyOfficeHoursToQueue}
          disabled={locked}
        />
      </div>
    </div>
  );
}